import { gql } from "@apollo/client";
import { print } from "@apollo/client/utilities";

export const UPDATE_QUERY = print(gql`
  mutation UpdateFormResponse($data: UpdateFormResponseInput!) {
    updateFormResponse(data: $data) {
      id
      status
      internalInfo
    }
  }
`);

export interface UpdateGql {
  updateFormResponse: {
    id: number;
    status?: string;
    internalInfo?: string;
  };
}
